import ShapeOverlays from './loader'
import viewport from "./viewport";

export default  function () {

    window.onpageshow = function(event) {
        if (event.persisted) {
            window.location.reload()
        }
    };


    let elmOverlay = document.querySelector('.shape-overlays');
    let overlay;
    if(elmOverlay) {
        overlay = new ShapeOverlays(elmOverlay);
    }


    document.addEventListener('click', function(event) {

        if (!event.target.closest('.js-change-page')) return;

        let link = event.target.closest('.js-change-page');

        if(viewport().width < 768 && link.classList.contains('header-cart__link')) {
            if($('.header-cart-drop').length > 0) {
                return;
            }
        }
        if(viewport().width < 768 && link.classList.contains('catalog-menu-drop__link')) {
            return;
        }

        let linkClicked = link.getAttribute('href');

        if(linkClicked !== '#' && linkClicked) {
            event.preventDefault();
            changePage(linkClicked);
        }

    });


    function changePage(link) {
        if(overlay){
            overlay.open();
        }

        window.setTimeout(function () {
            window.location = link;
        }, 700);
    }

    window.changePage = changePage
}
